import { authService } from '../api';
import { useApi } from './useApi';
import { showToast } from '../utils/toast';

export const useResendToken = () => {
  const {
    loading: resending,
    error,
    execute,
  } = useApi({
    successMessage: 'Verification token has been resent to your email!',
    showSuccessToast: true,
    showErrorToast: true,
  });

  const resendToken = async (email: string) => {
    if (!email) {
      showToast.error('Please enter your email address');
      return;
    }
    return execute(() => authService.resendVerificationToken(email));
  };

  return {
    resendToken,
    resending,
    error,
  };
};
